export default __webpack_public_path__ + "static/media/utilization_tab_icon.80263f60.svg";